/**
 * @class
 * @description Wrapper class that injects our modified hlsjs loader in a Flowplayer instance.
 * @exports Flowplayer
 */
export default class Flowplayer {
    /**
     * Constructs Flowplayer adapter.
     * @param {Object} player Flowplayer player instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(player) {
        this._player = player;
        this._loadEngine();
    }
    /**
     * Loads the CDN-P2P hlsjs engine, and tracking mechanism too.
     * @private
     */
    _loadEngine() {
        setTimeout(() => {
            try {
                if (this._player.hls) {
                    this._player.hls.config.loader = Flowplayer._adapters.getLoaders().LoaderHlsjs;
                    this._player.hls.config.loader._engine.setManifestResource(this._player.hls.url);
                }
                else if (this._player.dash) {
                    new (Flowplayer._adapters.getLoaders().LoaderDash)(this._player.dash);
                    Flowplayer._adapters.getLoaders().LoaderDash._engine.setManifestResource(this._player.dash.getSource());
                }
            }
            catch (err) {
                console.error(err);
            }
        }, 0);
    }
}
